import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { BehaviorSubject, Subject, EMPTY } from 'rxjs';

@Injectable({
  providedIn: 'root',
})

export class UploadAddProductSliderModelService {
  public uploadAddProductSlider: BehaviorSubject<boolean>;
  public uploadAddsidenav: MatSidenav;
  uploadAddSliderCloseRqt: Subject<boolean>;
  uploadAddModelData: BehaviorSubject<any>;
  public shipToAccount: number;
  public uploadedProducts: any;

  constructor() {
    this.uploadAddProductSlider = new BehaviorSubject(false);
    this.uploadAddModelData = new BehaviorSubject(EMPTY);
    this.uploadAddSliderCloseRqt = new Subject();
  }

  activeSlider(value: string) {
    if (value === 'UploadAddBlanketProductSlider') {
      this.uploadAddProductSlider.next(true);
      this.uploadAddModelData.next(EMPTY);
      this.uploadAddsidenav.toggle();
    }
  }

  public SetBlanketSideNav(BlanketSideNavObj: MatSidenav) {
    this.uploadAddsidenav = BlanketSideNavObj;
  }

  public BlanketClose() {
    this.uploadAddModelData.next(EMPTY);
    this.uploadAddProductSlider.next(false);
    this.uploadAddsidenav.close();
  }

  public setData<T>(obj: T) {
    this.uploadAddModelData.next(obj);
  }

  public setRequestData<T>(obj: T) {
    this.uploadAddModelData.next(obj);
  }
}
